import { object, number, string } from "yup";
import { FREQUENCY_OPTIONS } from "./constants";

export const MESSAGES = {
  REQUIRED: "This field is required",
  POSITIVE_NUMBER: "Please enter a positive number",
  MINIMUM_LOWER_THAN_MAXIMUM: "Min value has to be smaller than max"
};

export const validationSchema = object().shape({
  maximumValue: number()
    .max(2000)
    .required(MESSAGES.REQUIRED)
    .typeError(MESSAGES.REQUIRED),
  minimumValue: number()
    .positive(MESSAGES.POSITIVE_NUMBER)
    .max(2000)
    .required(MESSAGES.REQUIRED)
    .when("maximumValue", (maximumValue, schema) => {
      if (maximumValue) {
        return schema.max(maximumValue, MESSAGES.MINIMUM_LOWER_THAN_MAXIMUM);
      }
    })
    .typeError(MESSAGES.REQUIRED),
  minimumDiscount: number().min(0).max(25).required(),
  frequency: string()
    .oneOf(FREQUENCY_OPTIONS.map((item) => item.value))
    .required(MESSAGES.REQUIRED)
});
